"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const external_link_svg_1 = __importDefault(require("../../../assets/images/icons/external-link.svg"));
const fallback_meta_img_svg_1 = __importDefault(require("../../../assets/images/icons/fallback-meta-img.svg"));
require("./credentialSupportingDocumentationsBlock.scss");
const credentialSupportingDocumentationsBlockTranslations_json_1 = __importDefault(require("./credentialSupportingDocumentationsBlockTranslations/credentialSupportingDocumentationsBlockTranslations.json"));
const react_bootstrap_1 = require("react-bootstrap");
function CredentialSupportingDocumentationsBlock(props) {
    props.addTranslation(credentialSupportingDocumentationsBlockTranslations_json_1.default);
    return (react_1.default.createElement("div", { id: "supporting-docs-block" },
        react_1.default.createElement("span", { className: "block-title" }, props.translate("supportingDocumentation").toString()),
        react_1.default.createElement("div", { className: "supporting-docs-grid" }, Array.isArray(props.supportingDocumentationsWithMeta) &&
            props.supportingDocumentationsWithMeta
                .filter((doc) => doc.url)
                .map((doc) => {
                const [imageError, setImageError] = (0, react_1.useState)(false);
                return (react_1.default.createElement("div", { className: "supporting-doc-box", key: doc.id },
                    react_1.default.createElement("div", { className: "document-row" },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: {
                                    maxWidth: "400px",
                                } }, doc.title) },
                            react_1.default.createElement("span", { id: `supporting-doc-title-${doc.id}`, className: "doc-title" }, doc.title)),
                        react_1.default.createElement("a", { href: doc.url, target: "_blank", rel: "noreferrer", className: "external-link-icon" },
                            react_1.default.createElement("img", { src: external_link_svg_1.default, alt: "external-link", width: 15, height: 15 }))),
                    react_1.default.createElement("div", { className: "meta-box" },
                        doc.metaImageUrl && !imageError ? (react_1.default.createElement("img", { src: doc.metaImageUrl, alt: doc.title, onError: () => {
                                setImageError(true);
                            }, className: "meta-img" })) : (react_1.default.createElement("div", { className: "fallback-meta-cont" },
                            react_1.default.createElement("img", { src: fallback_meta_img_svg_1.default, alt: "fallback-meta-img", className: "fallback-meta-img" }))),
                        react_1.default.createElement("div", { className: "meta-info-col" },
                            doc.metaTitle && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: {
                                            maxWidth: "400px",
                                        } }, doc.metaTitle) },
                                    react_1.default.createElement("span", { id: `supporting-doc-meta-title-${doc.id}`, className: "meta-title" }, doc.metaTitle)))),
                            doc.metaDescription && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: {
                                            maxWidth: "400px",
                                        } }, doc.metaDescription) },
                                    react_1.default.createElement("span", { id: `supporting-doc-meta-desc-${doc.id}`, className: "meta-desc" }, doc.metaDescription)))),
                            react_1.default.createElement("a", { href: doc.url, target: "_blank", rel: "noreferrer", className: "meta-link" }, doc.url)))));
            }))));
}
exports.default = CredentialSupportingDocumentationsBlock;
